// Copied form Ligin.js
import { useEffect, useState } from 'react';
import awsconfig from '../aws-exports';
import axios from '../utils/axios';
import { processEnv } from 'src/env';

function createPdfUrl(fileName) {
  return `https://${awsconfig.Storage.AWSS3.bucket}.${processEnv.REACT_APP_S3_DOC_FOLDER}${fileName}`;
}

export function usePdfDocumentLinks() {
  const [termsDoc, setTermsDoc] = useState('');
  const [privacyDoc, setPrivacyDoc] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/user-termsPrivacyDocuments');
        let latestTerms = '0';
        let latestTermsFileName = '';
        let latestPrivacy = '0';
        let latestPrivacyFileName = '';
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === 'terms' && parseInt(data[i].version, 10) > parseInt(latestTerms, 10)) {
            latestTerms = data[i].version;
            latestTermsFileName = data[i].name;
          }
          if (data[i].type === 'privacy' && parseInt(data[i].version, 10) > parseInt(latestPrivacy, 10)) {
            latestPrivacy = data[i].version;
            latestPrivacyFileName = data[i].name;
          }
        }
        setTermsDoc(createPdfUrl(latestTermsFileName));
        setPrivacyDoc(createPdfUrl(latestPrivacyFileName));
      } catch (error) {
        console.error('Error = ', error);
      }
    })();
  }, []);

  return {
    privacyDoc,
    termsDoc,
  };
}
